module.exports = __webpack_public_path__ + "img/inspiration-6@2x.43835f6.jpg";